import { getMeetingReservationDetail, TReservation } from "apis/meetings/meeting-reservation";
import { UserRole } from "utils/role";

//* INFO : 예약 위젯의 상세 모달이 띄워지는 위치 정보
export const getModalPosition = (top: number, right: number, bottom: number, left: number) => {
  const getWidgetTop = () => {
    if (top + 340 > window.innerHeight) {
      return window.innerHeight - 340;
    } else {
      return top;
    }
  };

  const getWidgetLeft = () => {
    if (right + 400 > window.innerWidth) {
      return left - 400;
    } else {
      return right;
    }
  };

  return { top: getWidgetTop() - 300, left: getWidgetLeft() };
};

//* INFO : 권한에 맞게 예약 상세 정보를 반환하는 함수
export const handleOpenInfo = async (
  googleEventId: string,
  meetingReservationId: string,
  meetingRoomId: string,
  isMyReservation: boolean,
  isPrivate: boolean,
  myRole: UserRole,
  isMyMeeting: boolean
): Promise<TReservation | null> => {
  //* 워크스페이스의 Owner, SuperAdmin, 참석자, 예약자는 예약 상세 정보를 볼 수 있습니다.
  //* 일반 사용자는 비공개 예약이 아닌 경우에만 예약 상세 정보를 볼 수 있습니다.

  if (isMyReservation || myRole === UserRole.Owner || myRole === UserRole.SuperAdmin || !isPrivate || isMyMeeting) {
    const res = await getMeetingReservationDetail({
      googleEventId: googleEventId,
      meetingReservationId: meetingReservationId,
      meetingRoomId: meetingRoomId,
    });

    if (res.data) return res.data;
    else return null;
  } else return null;
};

//* INFO: 예약이 삭제/수정이 가능한지 확인하는 함수
export const isReservationEditable = (
  isMyReservation: boolean,
  isMyAttendee: boolean,
  myRole: UserRole,
  guestsCanModify: boolean,
  reservationState: string
) => {
  //* 본인 예약 내역 혹은 Owner, SuperAdmin은 예약 수정/삭제 가능
  //* 일정 조정 권한을 부여 받은 참석자도 예약 수정/삭제 가능
  if (reservationState === "WAIT" || reservationState === "ONAIR") {
    if (
      (isMyAttendee && guestsCanModify) ||
      myRole === UserRole.Owner ||
      myRole === UserRole.SuperAdmin ||
      isMyReservation
    )
      return true;
    else return false;
  } else return false;
};
